"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _permission = require("@/permission");
var _store = _interopRequireDefault(require("@/store"));
var _userAgent = require("@/utils/userAgent");
const commonRoutes = [{
  path: '/',
  beforeEnter: async (to, from, next) => {
    if ((0, _userAgent.isQywx)()) {
      await (0, _permission.handleOauth2Login)(to, from, next);
      return;
    }
    if (!_store.default?.getters?.userId) {
      next('/user/login');
      return;
    }
    next(_store.default.getters.firstMenuPath);
  }
}, {
  path: '/user',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "layouts" */'@/page/index/layout.vue'))),
  redirect: '/user/login',
  hidden: true,
  children: [{
    path: '/user/login',
    name: 'login',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "user" */'@/views/user/login'))),
    meta: {
      title: '登录',
      auth: false
    }
  }, {
    path: '/user/pwd/reset',
    name: 'UserPwdReset',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "user" */'@/views/user/pwd/reset.vue'))),
    meta: {
      title: '重置密码',
      auth: false
    }
  }, {
    path: '/user/pwd/modify',
    name: 'UserPwdModify',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "user" */'@/views/user/pwd/modify.vue'))),
    meta: {
      title: '修改密码',
      auth: true
    }
  }, {
    path: 'lose',
    name: 'lose',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "user" */'@/views/user/lose'))),
    meta: {
      title: '暂无访问权限',
      auth: false
    }
  }]
}, {
  path: '/logistics-leadsCollect-qrcode',
  name: 'LogisticsLeadsCollectQrcode',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "fail" */'@/views/logisticsLeadsCollectQrcode/index.vue'))),
  meta: {
    title: '线索录入二维码',
    auth: false
  }
}, {
  path: '/message',
  name: 'message',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "fail" */'@/views/message/index.vue'))),
  meta: {
    title: '电子名片',
    auth: false
  }
}, {
  path: '/403',
  name: '403',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "fail" */'@/views/exception/403'))),
  meta: {
    title: '无权限查看',
    auth: false
  }
}, {
  path: '/500',
  name: '500',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "fail" */'@/views/exception/500'))),
  meta: {
    title: '系统错误',
    auth: false
  }
}, {
  path: '/404',
  name: '404',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "fail" */'@/views/exception/404'))),
  meta: {
    title: '页面不存在',
    auth: false
  }
}, {
  path: '*',
  redirect: '/404'
}];
var _default = exports.default = commonRoutes;